import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaginatorComponent} from '@shared/components/pagination/paginator.component';
import {LoaderComponent} from '@shared/components/loader/loader.component';
import {FormInputModule} from '@shared/form-input/form-input.module';
import {CollapsibleContentComponent} from './components/collapsible-content/collapsible-content.component';
import {ConfirmDialogModule} from '@shared/confirmDialog/confirm-dialog.module';
import {PipelineDisplayComponent} from './components/pipeline-display/pipeline-display.component';
import {InfoMessageIconPipe} from './pipes/info-message-icon.pipe';
import {ModalModule} from '@shared/modal/modal.module';
import {MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorModule} from '@angular/material/paginator';
import {CheckboxComponent} from './components/checkbox/checkbox.component';
import {SelectItemTextPipe} from './pipes/select-item-text.pipe';
import {FormControlFromFormGroupPipe} from '@shared/pipes/form-control-from-form-group.pipe';
import {FocusInvalidDirective} from './directives/focus-invalid.directive';
import {TooltipComponent} from './components/tooltip/tooltip.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MailToPipe} from './pipes/mail-to.pipe';
import {TableColumnSelectorComponent} from '@shared/components/table-column-selector/table-column-selector.component';
import {FileGalleryComponent} from 'src/modules/shared/components/image-gallery/file-gallery.component';
import {NewLineToBrPipe} from './pipes/new-line-to-br.pipe';
import {MarketplaceNamePipe} from './pipes/marketplace-name.pipe';
import {ProductFieldValueByNamePipe} from '@shared/pipes/product-field-value-by-name.pipe';
import {StockCategoryPipe} from '@shared/pipes/stock-category.pipe';
import {PimDatePipe} from 'src/modules/shared/pipes/pim.date.pipe';
import {PageTitlePipe} from '@shared/pipes/page-title.pipe';
import {TextFilterComponent} from '@shared/components/text-filter/text-filter.component';
import {
	DynamicFieldValueTagListComponent
} from 'src/modules/shared/components/dynamic-field-value-tag-list/dynamic-field-value-tag-list.component';
import {ContentLanguageSwitchComponent} from './components/content-language-switch/content-language-switch.component';
import {ShortTextPipe} from './pipes/short-text.pipe';
import {ValueDisplayComponent} from './components/value-display/value-display.component';
import {ProductIdentifierLinkComponent} from './components/product-identifier-link/product-identifier-link.component';
import {RouterModule} from '@angular/router';
import {FormArrayLengthPipe} from './pipes/form-array-length.pipe';
import {SortComponent} from '@shared/components/sort/sort.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FieldsOfLabelMapPipe} from '@shared/pipes/fields-of-label-map.pipe';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormInputModule,
		FormsModule,
		ConfirmDialogModule,
		ModalModule,
		MatPaginatorModule,
		MatTooltipModule,
		RouterModule,
		DragDropModule,
	],
	declarations: [
		PaginatorComponent,
		LoaderComponent,
		CollapsibleContentComponent,
		PipelineDisplayComponent,
		InfoMessageIconPipe,
		CheckboxComponent,
		SelectItemTextPipe,
		FormControlFromFormGroupPipe,
		FocusInvalidDirective,
		TooltipComponent,
		MailToPipe,
		TableColumnSelectorComponent,
		FileGalleryComponent,
		NewLineToBrPipe,
		MarketplaceNamePipe,
		ProductFieldValueByNamePipe,
		StockCategoryPipe,
		PimDatePipe,
		PageTitlePipe,
		TextFilterComponent,
		DynamicFieldValueTagListComponent,
		ContentLanguageSwitchComponent,
		ShortTextPipe,
		ValueDisplayComponent,
		ProductIdentifierLinkComponent,
		FormArrayLengthPipe,
		SortComponent,
		FieldsOfLabelMapPipe,
	],

	exports: [
		// - MODULES
		ReactiveFormsModule,
		FormsModule,
		FormInputModule,
		ConfirmDialogModule,
		ModalModule,
		MatPaginatorModule,
		MatTooltipModule,
		// - COMPONENTS
		PaginatorComponent,
		LoaderComponent,
		CollapsibleContentComponent,
		PipelineDisplayComponent,
		CheckboxComponent,
		TooltipComponent,
		TableColumnSelectorComponent,
		FileGalleryComponent,
		TextFilterComponent,
		DynamicFieldValueTagListComponent,
		ContentLanguageSwitchComponent,
		SortComponent,
		// - PIPES
		InfoMessageIconPipe,
		SelectItemTextPipe,
		FormControlFromFormGroupPipe,
		MailToPipe,
		NewLineToBrPipe,
		MarketplaceNamePipe,
		ProductFieldValueByNamePipe,
		StockCategoryPipe,
		PageTitlePipe,
		FieldsOfLabelMapPipe,
		// - DIRECTIVES
		FocusInvalidDirective,
		PimDatePipe,
		ShortTextPipe,
		ValueDisplayComponent,
		ProductIdentifierLinkComponent,
		FormArrayLengthPipe,
	],
	providers: [{
		provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
		useValue: {
			// only set page-size-options globally. everything else is handled in the components, pagination-defaults and list-Endpoint Responses
			pageSizeOptions: [50, 100, 250, 500]
		}
	}
	]
})
export class SharedModule {
}
